module.exports = __webpack_public_path__ + "img/ConstructDeblanderLogoWhite.a1075c48.png";